import { useStepsContext } from './StepsContext';

export function useSteps() {
  return useStepsContext();
}
